import { useState } from "react";
import { ApiCall } from "../../../helper/axios";
import { getUserToken } from "../../../helper/commonFunction";
import moment from "moment";

export const getTimeSlots = (setLoadingAPI) => {
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [IsEventBased,setIsEventBased]=useState(false)

  const refresh = async (productId, excursionVariationId, StartDateTime, IsEventBased, isEmaarV1 = false,ResourceID) => {
    try {
      setLoadingAPI(true);
      setError("");
      if (!excursionVariationId || !StartDateTime) {
        return;
      }
      setLoading(true);
      const userToken = getUserToken();
      setIsEventBased(IsEventBased)
      if (IsEventBased) {
        if (isEmaarV1) {
          const details = await ApiCall(
            "GET",
            `excursionTimeSlotsWithRatesEmaarV1/?excursionVariationId=${excursionVariationId}&StartDateTime=${moment(StartDateTime).format("YYYY-MM-DD")}&userToken=${userToken}&productId=${productId}&ResourceID=${ResourceID}`,
            {},
            {},
            "excursion"
          );
          setData(details?.data);
        } else {
          const details = await ApiCall(
            "GET",
            `excursionTimeSlotsWithRates/?excursionVariationId=${excursionVariationId}&StartDateTime=${moment(
              StartDateTime
            ).format("YYYY-MM-DD")}&userToken=${userToken}&productId=${productId}`,
            {},
            {},
            "excursion"
          );
          setData(details?.data);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setLoadingAPI(false);
    }
  };

  const refreshUnifiedSlots = async (payload = {}) => {
    try {
      setLoadingAPI(true);
      setError("");
      setLoading(true);
      setIsEventBased(true);
      const details = await ApiCall(
        "POST",
        `/excursions/timeslot`,
        payload,
        {}
      );
      const body = details?.data;
      const unwrapped = body?.statusCode && body?.data ? body.data : body;
      if (unwrapped?.resultStatus === false && unwrapped?.message) {
        setError(unwrapped?.message);
      }
      setData(unwrapped ?? {});
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setLoadingAPI(false);
    }
  };

  const refreshHeliDubaiSchedules = async (
    excursionVariationId,
    excursionId,
    ScheduleDate,
    TourName,
    AdultSeats,
    ChildSeats,
    IsEventBased
  ) => {
    try {
      setLoadingAPI(true);
      setError("");
      if (!ScheduleDate || !AdultSeats || !TourName) {
        return;
      }
      const userToken = getUserToken();

      setLoading(true);
      const details = await ApiCall(
        "POST",
        `HeliDubai/GetTimeSlots`,
        {
          sdate: moment(ScheduleDate).format("YYYY-MM-DD"),
          edate: moment(ScheduleDate).format("YYYY-MM-DD"),
          id : excursionVariationId,
          pax : AdultSeats + ChildSeats,
          // AdultSeats: AdultSeats,
          // ChildSeats: ChildSeats,
          // TourName: TourName,
          userToken: userToken,
          excursionId,
        },
        {},
        "excursion"
      );
      setIsEventBased(IsEventBased)
      if (details?.data?.ResultStatus === false && details?.data?.message) {
        setError(details?.data?.message);
      }
      setData(details?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingAPI(false);
      setLoading(false);
    }
  };

  return {
    refresh,
    refreshHeliDubaiSchedules,
    refreshUnifiedSlots,
    data,
    loading,
    error,
    IsEventBased
  };
};